export default __webpack_public_path__ + "static/media/manInPlane.d2e77156.jpg";